import { combineReducers } from "redux";
import onLoadFunctionReducer from "./onLoadFunction-reducer";
import languageReducer from "./language-reducer";
import joinMeetingReducer from "./joinMeeting-reducer";
import surveyReducer from "./survey-reducer";
import notesReducer from "./notes-reducer";
import uploadFileReducer from "./uploadFile-reducer";
import endCallReducer from "./endCall-reducer";
import commonReducer from "./common-reducer";
import twilioEventsReducer from "./twilioEvents-reducer";
import chatReducer from "./chat-reducer";
import bookmarkReducer from "./bookmark-reducer";
import callSettingReducer from "./call-setting-reducer";
import imageContainerReducer from "./imageContainer-reducer";
import inviteReducer from "./invite-reducer";
import extractTextReducer from "./extractText-reducer";
import batteryNetworkInfoReducer from "./battery-network-info-reducer";
import recordingReducer from "./recording-reducer";
import livePointerReducer from "./livePointer-reducer";
import markupReducer from "./markup-reducer";
import liveLocationReducer from "./live-location-reducer";
import flashReducer from "./flash-reducer";
import silentObserverReducer from "./silentObserver-reducer";
import galleryViewReducer from "./gallery-view-reducer";
import callStatsReducer from "./callstats-reducer";
import trackFailedReducer from "./track-failed-reducer";
import measurementReducer from "./measurement-reducer";
import liveCaptionReducer from "./liveCaption-reducer";
import offlineModeReducer from "./offline-mode-reducer";
import askAIReducer from "./askAI-reducer";
import audioTranslationReducer from "./audioTranslation-reducer";

const Reducers = combineReducers({
    onLoadData: onLoadFunctionReducer,
    language: languageReducer,
    joinMeeting: joinMeetingReducer,
    survey: surveyReducer,
    notes: notesReducer,
    uploadFile: uploadFileReducer,
    endCall: endCallReducer,
    commonReducer: commonReducer,
    twilioEvents: twilioEventsReducer,
    chatReducer: chatReducer,
    bookmark: bookmarkReducer,
    callSetting: callSettingReducer,
    imageContainerReducer: imageContainerReducer,
    inviteParticipant: inviteReducer,
    extractText: extractTextReducer,
    batteryNetworkInfo: batteryNetworkInfoReducer,
    recording: recordingReducer,
    livePointer: livePointerReducer,
    markup: markupReducer,
    liveLocation: liveLocationReducer,
    flash: flashReducer,
    silentObserver: silentObserverReducer,
    galleryView: galleryViewReducer,
    callStats: callStatsReducer,
    trackFailed: trackFailedReducer,
    measurement: measurementReducer,
    liveCaption: liveCaptionReducer,
    offlineMode: offlineModeReducer,
    askAIReducer: askAIReducer,
    audioTranslation: audioTranslationReducer,
});

export default Reducers;
